module.exports = __webpack_public_path__ + "r-v3/img/refresh_white.c6795af4.svg";